import React from 'react';
import { Link } from 'react-router-dom';
import { MainRouteKeys } from 'routes/enums';
import { MainRoutesConfig } from 'routes/main/config';
import { useCurrentPath } from 'utils/hooks';

const Breadcrumbs = (): JSX.Element => {
  const { paths } = useCurrentPath();

  const getRouteOptions = (pathname: string, routePath?: string) => {
    return (
      MainRoutesConfig?.[pathname as MainRouteKeys] ||
      MainRoutesConfig?.[routePath as MainRouteKeys]
    );
  };

  return (
    <nav aria-label='breadcrumb' className='Breadcrumbs'>
      <ul>
        {paths.map((item, index) => {
          const routeOptions = getRouteOptions(
            item.pathname,
            String(item.route.path || ''),
          );
          const label = routeOptions?.name || item.pathname;

          return (
            <li key={item.pathname} className='breadcrumb-item'>
              {index === paths.length - 1 ? (
                <span className='breadcrumb-item active' aria-current='page'>
                  <BreadcrumbDetails getRouteOptions={label} />
                </span>
              ) : (
                <Link to={item.pathname}>{label}</Link>
              )}
              {index < paths.length - 1 && (
                <span className='separator'>{'>'}</span>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

function BreadcrumbDetails({ getRouteOptions }: { getRouteOptions: string }) {
  return <span>{getRouteOptions}</span>;
}

export default Breadcrumbs;
